import Vue from 'vue'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css'

import {
  Pagination,
  Message,
  Image,
  Loading,
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
  Collapse,
  CollapseItem,
  Drawer,
  Breadcrumb,
  BreadcrumbItem
} from 'element-ui'

Vue.use(Pagination)
Vue.use(Image)
Vue.use(Loading.directive)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(MenuItemGroup)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Drawer)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.prototype.$message = Message
Vue.prototype.$loading = Loading.service
